const VideoView = () => {
  return (
    <svg
      width="44"
      height="25"
      viewBox="0 0 44 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="33"
        y="18"
        width="11"
        height="7"
        rx="1.29072"
        fill="#A6A6A6"
        className="fs-switch-colour"
      />
      <rect
        x="33"
        y="9"
        width="11"
        height="7"
        rx="1.29072"
        fill="#A6A6A6"
        className="fs-switch-colour"
      />
      <rect
        x="33"
        width="11"
        height="7"
        rx="1.29072"
        fill="#A6A6A6"
        className="fs-switch-colour"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1.29072C0 0.577874 0.577874 0 1.29072 0H29.7093C30.4221 0 31 0.577874 31 1.29072V23.7093C31 24.4221 30.4221 25 29.7093 25H1.29072C0.577874 25 0 24.4221 0 23.7093V1.29072ZM20.7834 8.42294C20.7834 11.3823 18.3843 13.7814 15.4249 13.7814C12.4655 13.7814 10.0664 11.3823 10.0664 8.42294C10.0664 5.46353 12.4655 3.06445 15.4249 3.06445C18.3843 3.06445 20.7834 5.46353 20.7834 8.42294ZM7 22.9657C7 13.7799 23.8409 13.7799 23.8409 22.9656C16.9515 22.9659 12.3585 22.9659 7 22.9657Z"
        fill="#A6A6A6"
        className="fs-switch-colour"
      />
    </svg>
  );
};

export default VideoView;
